import { EngagementMedia } from '../../components/EngagementMedia'
import { useCommentData } from '../context/CommentContext'

import type { JSX } from 'react'

type CommentMediaProps = {
  className?: string
}

/**
 * Renders the media attached to the current comment (`comment.assets`).
 * Context-bound wrapper around the presentational `EngagementMedia`.
 */
export const CommentMedia = ({
  className,
}: CommentMediaProps): JSX.Element | null => {
  const comment = useCommentData()

  return <EngagementMedia assets={comment.assets} className={className} />
}
